import React from 'react';
import PropTypes from 'prop-types';
import { IconWithTooltip } from './IconWithTooltip';

export const EditIcon = ({ handleClick }) => (
  <IconWithTooltip
    handleClick={handleClick}
    ariaLabel="Edit Selection"
    tooltip="Edit Selection"
    icon="edit"
  />
);


EditIcon.propTypes = {
// eslint-disable-next-line react/require-default-props
  handleClick: PropTypes.func,
  // ariaLabel: PropTypes.string,
};

/*
EditIcon.defaultProps = {
  ariaLabel: 'Edit Selection',
};
*/
